module.exports = __webpack_public_path__ + "img/Bodice-Front-B4-Gd-Da-Eb.bf334d6a.png";